import React from 'react';
import { CQFileUploadManager } from '../api/CQFileUploadManager';

const fileUploader = new CQFileUploadManager();
const CQFileUploaderContext = React.createContext(fileUploader);

export default CQFileUploaderContext;